import { Flex, Heading } from "@hopper-ui/components";
import { SettingsRichIcon } from "@hopper-ui/icons";
import { PageLoading, PersonalizationForm, useSharedTranslation } from "@workleap-ai/shared";
import { Suspense } from "react";

const PersonalizationPage = () => {
    const { tShared } = useSharedTranslation();

    return (
        <Suspense fallback={<PageLoading />}>
            <PersonalizationForm
                header={
                    <Flex alignItems="center" gap="inline-md">
                        <SettingsRichIcon size="xl" />
                        <Heading marginBottom="core_0">{tShared("personalization.title")}</Heading>
                    </Flex>
                }
                border="neutral-weak"
                paddingY="inset-xl"
            />
        </Suspense>
    );
};

export default PersonalizationPage;
